import { getAnimateRotationStyle, Spacing, transientOptions } from '@billy/design-system'
import styled from '@emotion/styled'

interface IconWrapperProps {
  $loading?: boolean
}

export const IconWrapper = styled('figure', transientOptions)<IconWrapperProps>`
  margin-right: ${Spacing.S6};

  ${({ $loading }) => $loading && getAnimateRotationStyle()};
`
